module.exports = "/assets/data/be97175a1031f604b2997043dc70980f-AB33.data.json";